module.exports = __webpack_public_path__ + "img/ss-7.8f368221.png";